// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__W34I_","overflowing":"ReadFullNote_overflowing__DyfLh"};